module.exports = __webpack_public_path__ + "img/bilet.86eecbb0.svg";